import React from 'react';
import CreateTagStationModal from '../../shared/component/tag/CreateTagStationModal';
import CreateTagStationModalMobile from '../../shared/component/tag/mobile/CreateTagStationModalMobile';
import { useTextTag } from '../../shared/hooks/useApi/useTextTag';

interface CreateTextTagModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const CreateTextTagModal: React.FC<CreateTextTagModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const { createTextTag } = useTextTag();
  const modalProps = {
    createTag: createTextTag,
    setIsUserInput,
  };

  return isMobile
    ? <CreateTagStationModalMobile {...modalProps} />
    : <CreateTagStationModal {...modalProps} />;
};

export default CreateTextTagModal;
